import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { PRODUCTS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getProductTranslationsAction = createAsyncThunk(
    'product/getProductTranslationsAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ PRODUCTS_PATH }/${ data.productId }/translations`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getProductTranslationsSlice = createSlice({
    name: 'getProductTranslationsSlice',
    initialState: DEFAULT_STATE,
    reducers: {
        invalidateProduct() {
            return DEFAULT_STATE;
        }
    },
    extraReducers: builder => {
        builder.addCase(getProductTranslationsAction.pending, () => STATE__API__STARTED);
        builder.addCase(getProductTranslationsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getProductTranslationsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { invalidateProduct } = getProductTranslationsSlice.actions;
export const getProductTranslationsState = (state) => state.product.getProductTranslations;
export default getProductTranslationsSlice.reducer;